import { isAnyOf } from '@reduxjs/toolkit';
import { WorkspaceSettingWindow } from '../../../types/workspaces';
import { setSetting } from '../slices/settings-slice';
import { createView } from '../slices/views-slice';
import {
    addPanelToWindow,
    closeAllWindows,
    closeWindow,
    createWindow,
    removePanelFromWindow,
    setWindowPanelOrder,
    setWorkspaceLayout,
    setWorkspacePanelVisibility,
    updatePanelInWindow,
    updateWindowBounds,
    workspaceSwitchView
} from '../slices/workspace-slice';
import { startAppListening } from './listener-middleware';

export function startWorkspaceSettingsListener() {
    startAppListening({
        matcher: isAnyOf(
            setWorkspacePanelVisibility,
            setWorkspaceLayout.fulfilled,
            workspaceSwitchView.fulfilled,
            createView.fulfilled,
            createWindow,
            closeWindow,
            closeAllWindows,
            addPanelToWindow,
            updatePanelInWindow,
            setWindowPanelOrder,
            removePanelFromWindow,
            updateWindowBounds
        ),
        effect: async (_, api) => {
            api.cancelActiveListeners();
            await api.delay(500);
            const state = api.getState();
            const views = [...state.settings.workspaceConfig.views];
            for (const item of state.workspace.items) {
                const idx = views.findIndex((x) => x.workspaceId === item.id);
                if (idx > -1) {
                    views[idx] = {
                        ...views[idx],
                        viewId: item.view.id
                    };
                } else {
                    views.push({
                        workspaceId: item.id,
                        viewId: item.view.id
                    });
                }
            }
            api.dispatch(
                setSetting('workspaceConfig', {
                    layout: state.workspace.layout,
                    panels: {
                        airportMonitor: state.workspace.panels.airportMonitor,
                        fleetMonitor: state.workspace.panels.fleetMonitor,
                        eventList: state.workspace.panels.eventList,
                        legend: state.workspace.panels.legend,
                        routeAnalyzer: state.workspace.panels.routeAnalyzer
                    },
                    views,
                    windows: state.workspace.windows.map(
                        (x) =>
                            ({
                                version: 2,
                                id: x.id,
                                panels: x.panels.map((x) => ({
                                    type: x.type,
                                    airportId: x.airportId
                                })),
                                bounds: x.bounds
                                    ? {
                                          x: x.bounds.screenX,
                                          y: x.bounds.screenY,
                                          width: x.bounds.width,
                                          height: x.bounds.height
                                      }
                                    : null
                            }) satisfies WorkspaceSettingWindow
                    )
                })
            );
        }
    });
}
